export class Sound {
  constructor(context) {
    this.context = context
    this.oscillator = null
    this.gainNode = null
  }

  init() {
    this.oscillator = this.context.createOscillator()
    this.gainNode = this.context.createGain()

    this.oscillator.connect(this.gainNode)
    this.gainNode.connect(this.context.destination)
    this.oscillator.type = 'sine'
  }

  play(frequency, duration) {
    this.init()
    if (!this.oscillator || !this.gainNode) return

    const now = this.context.currentTime

    this.oscillator.type = 'triangle' // Более "колокольный" тембр
    this.oscillator.frequency.setValueAtTime(frequency, now)

    // Быстрое затухание для имитации колокольчика
    this.gainNode.gain.setValueAtTime(0.7, now)
    this.gainNode.gain.exponentialRampToValueAtTime(0.001, now + duration)

    this.oscillator.start(now)
    this.oscillator.stop(now + duration)
  }

  stop(startTime, duration) {
    if (!this.gainNode || !this.oscillator) return

    this.gainNode.gain.exponentialRampToValueAtTime(0.001, startTime + duration)
    this.oscillator.stop(startTime + duration)
  }
}
